import { FormControl, FormGroup, Validators } from '@angular/forms';

import { LogItem } from './log-item.interface';

export interface SaveFeedbackResponse {
  success: boolean;
  errors: LogItem[];
  troubleCards: TroubleCardRow[];
  sheets?: ParsedSheet[];
  purchasedCards?: PurchasedCardRow[];
  last4Cards?: Last4CardRow[];
  accountHolderCards?: AccountHolderCardRow[];
  botnetCards?: BotnetCardRow[];
}

export interface ParsedSheet {
  name: string;
  cards: SheetRow[];
}

export interface SheetRow {
  [key: string]: any;
}
export interface TroubleCardRow extends CardsFeedbackTableRow {}
export interface PurchasedCardRow extends CardsFeedbackTableRow {}
export interface Last4CardRow extends CardsFeedbackTableRow {}
export interface AccountHolderCardRow extends CardsFeedbackTableRow {}
export interface BotnetCardRow extends CardsFeedbackTableRow {}

export interface CardsFeedbackTableRow {
  [key: string]: any;
}

export interface SheetResult {
  name: string;
  active: boolean;
  columns: string[];
  rows: SheetRow[];
  mappings: { [key: string]: string | null };
}

export const cardsFeedbackForm = () => {
  const form = new FormGroup({
    client: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    language: new FormControl<string>('EN', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    file: new FormControl<File | null>(null),
  });

  return form;
};
